import { IconCtaBorderedCardProps } from '@ahc-digital/component-library';
import { C31IconCTABorderedCardProps } from './C31IconCTABorderedCard.types';
import { useConditionalRendering } from '@/shared/useConditionalRendering';
import { getDroplink } from '@/shared/param-utils';
import { getKvpValue } from 'src/shared/field-utils';

export function CreateIconCTABorderedCardModel(props?: C31IconCTABorderedCardProps) {
  type t = IconCtaBorderedCardProps;
  const { params, fields } = props || {};
  const { renderRichText, renderLink, renderText } = useConditionalRendering();

  return {
    icon: getKvpValue<t['icon']>(fields?.Icon),
    firstCTAStyle: getDroplink<t['firstCTAStyle']>(params?.FirstCTAStyle, 'button'),
    secondCTAStyle: getDroplink<t['secondCTAStyle']>(params?.SecondCTAStyle, 'button'),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'h3'),
    topColorBar: getDroplink<t['topColorBar']>(params?.TopBorderColor, 'none'),
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    firstCTA: renderLink(fields?.FirstCTA),
    secondCTA: renderLink(fields?.SecondCTA),
  };
}
